"use client";
import Loader from "@/components/Loader";
import { Suspense, useState } from "react";
import { Search } from "../../Search/GlobalSearch";
import { AemSearchDropDown, AemSearchResults } from "@/utils/types/aem";
import useMediaQuery from "@/utils/hooks/useMediaQuery";
import { Button } from "@dxp-feed/ui";

export default function SearchWrapper({
  headerData,
  searchStaticAEMData,
}: {
  headerData: any;
  searchStaticAEMData: {
    dropdown: AemSearchDropDown;
    resultsPage: AemSearchResults;
  };
}) {
  const mobileMedia: number = useMediaQuery() || 0;
  const isMobile = mobileMedia && (mobileMedia <= 1023);
  const [visible, setVisible] = useState(false);
  return (
    <div
      onClickCapture={() => {
        if (isMobile) {
          setVisible(true);
        }
      }}
      className={`desktop-search block md:hidden lg:block z-10 ${
        visible && isMobile
          ? "[&_.overlay]:!hidden bg-brandSecondary mx-[-24px] [&_.dropDown]:!w-auto left-0 right-0 [&_.dropDown]:!left-[24px] py-[12px] px-[24px]  [&_.dropDown]:!right-[24px] absolute [&_.dropDown]:min-h-[calc(100vh-20vh)] [&_.dropDown]:!mt-[0px] z-[9999999] flex "
          : "flex-1  !md:mx-0 !2lg:ml-6 !lg:mx-0 mr-3 3xl:mr-0 lg:!ml-3 ml-auto max-w-[calc(100%-90px)]"
      } `}
    >
      <Suspense fallback={<Loader />}>
        <Search
          placeholder={headerData["header"]?.searchplaceholder}
          onClose={setVisible}
          searchStaticAEMData={searchStaticAEMData}
        />
      </Suspense>
      {visible && isMobile && (
        <>
          <Button
            className={`!text-body xs:!text-base text-brandWhite !transition-none underline p-0 pl-3 pr-1 hover:none rounded-none border-none z-[9999999] relative `}
            variant="icon"
            aria-label={"Cancel"}
            onClick={() => setVisible(false)}
          >
            Cancel
          </Button>
          <div
            className="fixed w-full h-full z-[99] top-0 left-0 right-0 bg-overlay"
            onClick={() => setVisible(false)}
          >
            {" "}
          </div>
        </>
      )}
    </div>
  );
}
